module.exports = __webpack_public_path__ + "img/products.ff166679.jpg";